import React, { useState } from 'react';
import { Box, IconButton, Menu } from '@mui/material';
import { GridMoreVertIcon } from '@mui/x-data-grid';
import ActionToolsBar from './ActionToolsBar';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { COLOR_PRIMARY_1 } from 'src/utils/colors';
import { logAmplitudeEvent } from 'src/utils/analytics';

const ActionOptions = ({
  setShowListingsExportPage,
  handleOnSampleClick,
  setShowSubmarketCreationModal,
  marketID,
  marketName,
  setUserRemovedThisMarketFromOverview,
  isLoggedIn,
  setShowExportAsPDFModal,
  isPDFDataToDownloadLoading,
  showExportDashboardOption,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    logAmplitudeEvent('kebab_menu_openend');
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <IconButton
          aria-label="more"
          aria-controls="icon-menu"
          aria-haspopup="true"
          onClick={handleClick}
          sx={{
            p: 0,
            m: 0,
          }}
        >
          <GridMoreVertIcon />
        </IconButton>
        <Menu
          id="icon-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Box sx={{ padding: '2px 10px' }}>
            <ActionToolsBar
              setShowListingsExportPage={setShowListingsExportPage}
              handleOnSampleClick={handleOnSampleClick}
              setShowSubmarketCreationModal={setShowSubmarketCreationModal}
              marketID={marketID}
              marketName={marketName}
              setUserRemovedThisMarketFromOverview={setUserRemovedThisMarketFromOverview}
              isLoggedIn={isLoggedIn}
              setShowExportAsPDFModal={setShowExportAsPDFModal}
              isPDFDataToDownloadLoading={isPDFDataToDownloadLoading}
              handleClose={handleClose}
              showExportDashboardOption={showExportDashboardOption}
            />
          </Box>
          <CancelTwoToneIcon
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              fontSize: '24px',
              color: COLOR_PRIMARY_1,
              background: 'white',
              cursor: 'pointer',
              borderRadius: '4px',
            }}
            onClick={() => setAnchorEl(null)}
          />
        </Menu>
      </div>
    </>
  );
};

export default ActionOptions;
